import React, { FC } from "react";
import { ACD } from "../../../models";
import { ConfirmInputGroup } from "./shared/confirmInputGroup";
import CommonModal from "../components/commonModal";
import ModalButtons from "./shared/modalButtons";
import useModalState from "./hooks/useModalState";

const getError = (id: string, message: string): string => {
  return !id || !message ? "Please select a client and enter a note to update client" : "";
};

interface Props {
  show: boolean;
  handleClose: () => void;
  handleSave: (client: number, message: string) => void;
  clientList: ACD[];
}

export const AssignClientModal: FC<Props> = ({ show = false, handleClose, handleSave, clientList }) => {
  const { close, errorComponent, id, message, save, setId, setMessage } = useModalState(
    handleClose,
    handleSave,
    getError
  );

  return (
    <CommonModal
      show={show}
      title="Update Client"
      onHide={close}
      buttons={<ModalButtons close={close} save={save} saveLabel="Update Client" />}
    >
      {errorComponent}
      {clientList.length > 0 ? (
        <ConfirmInputGroup
          choices={clientList.map((client: ACD) => {
            return {
              id: client.clientId,
              label: client.clientName,
            };
          })}
          handleIdChange={setId}
          handleNoteChange={setMessage}
          id={id ? id : ""}
          note={message}
          title="Client"
          placeholder="Select Client"
        />
      ) : (
        <>There are no clients found</>
      )}
    </CommonModal>
  );
};
